import { Backdrop, CircularProgress } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import { indigo } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import HistoryIcon from '@material-ui/icons/History';
import LockIcon from '@material-ui/icons/Lock';
import PeopleIcon from '@material-ui/icons/People';
import classNames from 'classnames';
import firebase from 'firebase/app';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import CheckInDialog from './CheckInDialog.js';
import CustomersTable from './CustomersTable.js';
import DeskHistoryTable from './DeskHistoryTable.js';
import DeskInUseTable from './DeskInUseTable.js';
import ExportPage from './ExportPage.js';
import ImportCustomerDialog from './ImportCustomerDialog.js';
import PassesTable from './PassesTable.js';
import PassReportPage from './PassReportPage.js';
import PriceTable from './PriceTable.js';
import ReportPage from './ReportPage.js';
import ResetPasswordDialog from './ResetPasswordDialog';
import RoomApplicationTable from './RoomApplicationTable.js';
import RoomHistoryTable from './RoomHistoryTable.js';
import RoomScheduleTable from './RoomScheduleTable.js';
import RoomTable from './RoomTable.js';
import StaffDailog from './StaffDialog.js';
import StaffsTable from './StaffsTable.js';
import TestPage from './TestPage.js';

require("firebase/firestore");
require("firebase/functions");

// Permissions
const PERMISSION_DESK_TRANSACTION = "desk_transaction";
const PERMISSION_DESK_HISTORY = "desk_history";
const PERMISSION_PASS_REPORT = "pass_report";
const PERMISSION_REPORT_DAILY = "report_daily";
const PERMISSION_REPORT_HISTORY = "report_history";
const PERMISSION_SETTING_CUSTOMER = "setting_customer";
const PERMISSION_SETTING_DESK = "setting_desk";
const PERMISSION_SETTING_PASS = "setting_pass";
const PERMISSION_SETTING_PRICE = "setting_price";
const PERMISSION_SETTING_STAFF = "setting_staff";
const PERMISSION_EXPORT = "export";
const PERMISSION_TEST = "test";

// Pages
const PAGE_DESKS_IN_USE = { id: 'desksInUse', title: 'Desks In Use', permission: PERMISSION_DESK_TRANSACTION, icon: <Icon>airline_seat_legroom_normal</Icon> };
const PAGE_DESKS_HISTORY = { id: 'desksHistory', title: 'Desks History', permission: PERMISSION_DESK_HISTORY, icon: <HistoryIcon /> };
const PAGE_PASS_REPORT = { id: 'passReport', title: 'Pass Report', permission: PERMISSION_PASS_REPORT, icon: <AssignmentIcon /> };
const PAGE_BOOKINGS = { id: 'bookings', title: 'Room Schedule' };
const PAGE_BOOKINGS_APPLICATION = { id: 'bookingsApplication', title: 'Room Application' };
const PAGE_BOOKINGS_HISTORY = { id: 'bookingsHistory', title: 'Room History' };
const PAGE_CUSTOMERS = { id: 'customers', title: 'Customers', permission: PERMISSION_SETTING_CUSTOMER, icon: <PeopleIcon /> };
const PAGE_EVENTS = { id: 'events', title: 'Events' };
const PAGE_STUDY_GROUP = { id: 'groups', title: 'Study Groups' };
const PAGE_POSTS = { id: 'posts', title: 'Posts' };
const PAGE_DESK = { id: 'desk', title: 'Desk', permission: PERMISSION_SETTING_DESK, icon: <EventSeatIcon /> };
const PAGE_PASSES = { id: 'passes', title: 'Passes', permission: PERMISSION_SETTING_PASS, icon: <CardGiftcardIcon /> };
const PAGE_PRICE = { id: 'price', title: 'Price', permission: PERMISSION_SETTING_PRICE, icon: <AttachMoneyIcon /> };
const PAGE_STAFFS = { id: 'staffs', title: 'Staffs', permission: PERMISSION_SETTING_STAFF, icon: <Icon>face</Icon> };
const PAGE_REPORT = { id: 'report', title: 'Daily Report', permission: PERMISSION_REPORT_DAILY, icon: <AssessmentIcon /> };
const PAGE_HISTORY_REPORT = { id: 'historyReport', title: 'Report History', permission: PERMISSION_REPORT_HISTORY, icon: <HistoryIcon /> };
const PAGE_EXPORT = { id: 'export', title: 'Export', permission: PERMISSION_EXPORT, icon: <Icon>file_download</Icon> };
const PAGE_TEST = { id: 'test', title: 'TEST', permission: PERMISSION_TEST, icon: <Icon>code</Icon> };

// Styles
const drawerWidth = 260;
const styles = theme => ({
  root: {
    width: '100%',
    height: '100vh',
    marginTop: 0,
    zIndex: 1,
    overflow: 'hidden',
  },
  flex: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  appBar: {
    position: 'absolute',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    height: '100%',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    width: 60,
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerInner: {
    // Make the items inside not wrap when transitioning:
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 24px',
    ...theme.mixins.toolbar,
  },
  content: {
    width: '100%',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: 24,
    height: 'calc(100% - 104px)',
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 112px)',
      marginTop: 64,
    },
    overflow: "scroll",
  },
  menuItemBackground: {
    borderLeft: `6px solid ${indigo[500]}`,
    backgroundColor: 'WhiteSmoke',
  },
  nestedMenuItem: {
    paddingLeft: theme.spacing(4),
  },
  dateFieldContrast: {
    marginTop: 3,
    fontSize: 21,
    color: '#EEEEEE',
  },
});

class MainDrawer extends React.Component {
  state = {
    currentUser: null,
    currentStaff: null,
    page: '',
    drawerOpen: true,
    loading: false,
    progress: 0,

    deskHistoryPageSelectedDate: moment().subtract(1, 'days').toDate(),
    reportPageSelectedDate: moment().toDate(),
    historyReportPageSelectedDate: moment().subtract(1, 'days').toDate(),

    dialogOpen: false,
    dialogTitle: '',
    dialogMessage: '',
    dialogAction: null,

    importCustomerFormOpen: false,
    deskTransactionDialogOpen: false,
    resetPasswordDialogOpen: false,
    staffDialogOpen: false,

    users: [],
    userPasses: {},
    passes: [],
    rooms: [],
    bookingStatus: [],
    priceRule: [],
    roles: [],
    branches: [],
    staffs: [],
  };

  worker = new Worker("/workers/union.js");

  // Listen current user
  listenCurrentUser = () => {
    console.time('listenCurrentUser');
    var currentUser = firebase.auth().currentUser;
    if (currentUser) {
      return firebase.firestore()
        .collection('users')
        .doc(currentUser.uid)
        .onSnapshot(doc => {
          let data = doc.data();
          data.id = doc.id;
          this.setState({ currentUser: data, });
          console.timeEnd('listenCurrentUser');
        });
    } else {
      return null;
    }
  }

  // Users
  queryUsers = () => {
    this.setState({ loading: true });

    return firebase.firestore()
      .collection("users")
      .onSnapshot(querySnapshot => {
        console.time('queryUsers');
        const users = this.state.users;

        _.chain(querySnapshot.docChanges())
          .filter(change => change.type === 'added' || change.type === 'modified')
          .map(change => ({ id: change.doc.id, ...change.doc.data() }))
          .value()
          .forEach(item => {
            const index = users.findIndex(user => user.id === item.id);
            if (index === -1) {
              users.push(item);
            } else {
              users[index] = item;
            }
          });

        this.setState({ users, loading: false });
        console.timeEnd('queryUsers');
      });
  }

  // UserPasses
  queryUserPasses = () => {
    console.time('queryUserPasses');
    return firebase.firestore()
      .collection("userPasses")
      .onSnapshot(querySnapshot => {
        let userPasses = this.state.userPasses;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            if (!userPasses[data.userId]) {
              userPasses[data.userId] = {};
            }

            userPasses[data.userId][data.passId] = data;
          }
        });
        this.setState({ userPasses: userPasses, });
        console.timeEnd('queryUserPasses');
      });
  }

  // Passes
  queryPasses = () => {
    console.time('queryPasses');
    return firebase.firestore()
      .collection('pass')
      .onSnapshot(querySnapshot => {
        let passes = this.state.passes;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = passes.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              passes.push(data);
            } else {
              passes[index] = data;
            }
          }
        });
        this.setState({
          passes: passes,
        });
        console.timeEnd('queryPasses');
      });
  }

  // PriceRule
  queryPriceRule = () => {
    console.time('queryPriceRule');
    return firebase.firestore()
      .collection('priceRule')
      .onSnapshot(querySnapshot => {
        let priceRule = this.state.priceRule;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = priceRule.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              priceRule.push(data);
            } else {
              priceRule[index] = data;
            }
          }
        });
        this.setState({ priceRule: priceRule, });
        console.timeEnd('queryPriceRule');
      });
  }

  // Rooms
  queryRooms = () => {
    console.time('queryRooms');
    return firebase.firestore()
      .collection('room')
      .onSnapshot(querySnapshot => {
        let rooms = this.state.rooms;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = rooms.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              rooms.push(data);
            } else {
              rooms[index] = data;
            }
          }
        });
        this.setState({
          rooms: rooms,
        });
        console.timeEnd('queryRooms');
      });
  }

  // BookingStatus
  queryBookingStatus = () => {
    console.time('queryBookingStatus');
    return firebase.firestore()
      .collection('status')
      .onSnapshot(querySnapshot => {
        let bookingStatus = this.state.bookingStatus;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = bookingStatus.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              bookingStatus.push(data);
            } else {
              bookingStatus[index] = data;
            }
          }
        });
        this.setState({
          bookingStatus: bookingStatus,
        });
        console.timeEnd('queryBookingStatus');
      });
  }

  // Roles
  queryRoles = () => {
    console.time('queryRoles');
    return firebase.firestore()
      .collection('roles')
      .onSnapshot(querySnapshot => {
        let roles = this.state.roles;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = roles.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              roles.push(data);
            } else {
              roles[index] = data;
            }
          }
        });
        this.setState({
          roles: roles,
        });
        console.timeEnd('queryRoles');
      });
  }

  // Branches
  queryBranches = () => {
    console.time('queryBranches');
    return firebase.firestore()
      .collection('branches')
      .where('active', '==', true)
      .onSnapshot(querySnapshot => {
        let branches = this.state.branches;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = branches.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              branches.push(data);
            } else {
              branches[index] = data;
            }
          }
        });
        this.setState({
          branches: branches,
        });
        console.timeEnd('queryBranches');
      });
  }

  // Staffs
  queryStaffs = () => {
    console.time('queryStaffs');
    return firebase.firestore()
      .collection("staffs")
      .onSnapshot(querySnapshot => {
        let staffs = this.state.staffs;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            let index = staffs.findIndex(element => {
              return element.id === change.doc.id;
            });
            if (index === -1) {
              staffs.push(data);
            } else {
              staffs[index] = data;
            }
          }
        });
        this.setState({ staffs: staffs, });
        console.timeEnd('queryStaffs');
      });
  }

  genMenuItem = (page, isChild, openStateKey) => {
    var currentUserRole = this.getCurrentUserRole();
    if (!currentUserRole || !currentUserRole.permissions.includes(page.permission)) {
      return null;
    }
    return (
      <ListItem
        key={page.id}
        button
        onClick={this.handleMenuItemClick(page)}
        className={`${this.state.page.id === page.id && this.state.page.branch === page.branch ? this.props.classes.menuItemBackground : ''} ${isChild && this.state.drawerOpen ? this.props.classes.nestedMenuItem : ''}`} >

        <Tooltip title={page.title} placement="top">
          <ListItemIcon>
            {page.icon}
          </ListItemIcon>
        </Tooltip>

        <ListItemText primary={page.title} />

        { openStateKey ?
          <ListItemSecondaryAction>
            <IconButton
              onClick={() => {
                var newState = {};
                newState[openStateKey] = !this.state[openStateKey];
                this.setState(newState);
              }} >
              {this.state[openStateKey] ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </ListItemSecondaryAction>
          : null
        }
      </ListItem>
    );
  }

  genMenuItemWithHistory = (page, historyPage) => {
    var currentUserRole = this.getCurrentUserRole();
    if (!currentUserRole || !currentUserRole.permissions.includes(page.permission)) {
      return null;
    }
    return (
      <ListItem
        key={page.id}
        button
        onClick={this.handleMenuItemClick(page)}
        className={`
          ${(this.state.page.id === page.id || this.state.page.id === historyPage.id) &&
            this.state.page.branch === page.branch ?
            this.state.page.branch === page.branch ?
              this.state.page.branch === page.branch ?
                this.props.classes.menuItemBackground :
                this.props.classes.menuItemBackground :
              this.props.classes.menuItemBackground :
            ''} 
          ${this.props.classes.nestedMenuItem}
        `} >

        <Tooltip title={page.title} placement="top">
          <ListItemIcon>
            {page.icon}
          </ListItemIcon>
        </Tooltip>

        <ListItemText primary={page.title} />

        <ListItemSecondaryAction>
          <IconButton
            onClick={this.handleMenuItemClick(historyPage)} >
            <HistoryIcon />
          </IconButton>
        </ListItemSecondaryAction>

      </ListItem>
    );
  }

  genBranchHeaderItem = (branch) => {
    return (
      <ListItem
        key={"header_" + branch.id}
        button
        onClick={() => {
          var newState = {};
          newState["menuOpen" + branch.id] = !this.state["menuOpen" + branch.id];
          this.setState(newState);
        }} >

        <Tooltip title={branch.name} placement="top">
          <ListItemIcon>
            <Icon>store</Icon>
          </ListItemIcon>
        </Tooltip>

        <ListItemText primary={branch.name} secondary={branch.id} />

        { <Icon color="action">{this.state["menuOpen" + branch.id] ? 'expand_less' : ' expand_more'}</Icon>}
      </ListItem>
    );
  }

  genBranchMenuItems = () => {
    let branchMenuItems = [];
    let currentUserBranchId = this.getCurrentUserBranchId();

    if (!currentUserBranchId) {
      return branchMenuItems;
    }

    this.state.branches.forEach(branch => {
      if (currentUserBranchId === "all" || currentUserBranchId === branch.id) {
        // Desk In Use
        const deskInUsePage = Object.assign({ branch }, PAGE_DESKS_IN_USE);
        const deskHistoryPage = Object.assign({ branch }, PAGE_DESKS_HISTORY);

        // Report
        const reportPage = Object.assign({ branch }, PAGE_REPORT);
        const reportHistoryPage = Object.assign({ branch }, PAGE_HISTORY_REPORT);

        // Price
        const pricePage = Object.assign({ branch }, PAGE_PRICE);
        
        // Pass
        const passPage = Object.assign({ branch }, PAGE_PASSES);

        const mi_branch = this.genBranchHeaderItem(branch);
        const mi_deskTransaction = this.genMenuItemWithHistory(deskInUsePage, deskHistoryPage);
        const mi_report = this.genMenuItemWithHistory(reportPage, reportHistoryPage);
        const mi_price = this.genMenuItem(pricePage, true);
        const mi_passes = this.genMenuItem(passPage, true);

        branchMenuItems.push(mi_branch);
        branchMenuItems.push(
          <Collapse key={"items_" + branch.id} component="li" in={this.state["menuOpen" + branch.id]} timeout="auto" unmountOnExit>
            <List disablePadding>
              {mi_deskTransaction}
              {mi_report}
              {mi_price}
              {mi_passes}
            </List>
          </Collapse>
        );
      }
    });

    return branchMenuItems;
  }

  getCurrentUserRole = () => {
    return this.state.currentUser &&
      this.state.roles &&
      this.state.roles.find(role => role.id === this.state.currentUser.role);
  }

  getCurrentUserBranchId = () => {
    let role = this.getCurrentUserRole();
    let roleId = role && role.id;
    switch (roleId) {
      case "admin":
        return "all";
      case "staff":
        let branch = this.state.currentUser &&
          this.state.branches &&
          this.state.branches.find(branch => branch.id === this.state.currentUser.branch);
        return branch && branch.id;
      default:
        return null;
    }
  }

  handleDrawerOpen = () => {
    this.setState({ drawerOpen: true });
  };

  handleDrawerClose = () => {
    this.setState({ drawerOpen: false });
  };

  handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };

  handleResetPassword = () => {
    this.handleResetPasswordDialogOpen();
  }

  handleSignOut = () => {
    this.setState({
      dialogOpen: true,
      dialogTitle: 'Sign Out',
      dailogButtonText: 'Sign Out',
      dialogMessage: 'Are you sure to sign out?',
      dialogAction: () => {
        firebase.auth().signOut();
      },
    });
  }

  handleMenuItemClick = page => event => {
    this.setState({
      page: page,
    });
  };

  handleImportCustomerFormOpen = () => {
    this.setState({ importCustomerFormOpen: true });
  }

  handleImportCustomerFormClose = () => {
    this.setState({ importCustomerFormOpen: false });
  }

  handleRegistrationDialogOpen = () => {
    window.open("https://mybase-hk.firebaseapp.com/", "_blank");
  }

  handleRegistrationDialogClose = () => {
    this.setState({ registrationDialogOpen: false });
  }

  handleDeskTransactionDialogOpen = () => {
    this.setState({ deskTransactionDialogOpen: true });
  }

  handleDeskTransactionDialogClose = () => {
    this.setState({ deskTransactionDialogOpen: false });
  }

  handleResetPasswordDialogOpen = () => {
    this.setState({ resetPasswordDialogOpen: true });
  }

  handleResetPasswordDialogClose = () => {
    this.setState({ resetPasswordDialogOpen: false });
  }

  handleStaffDialogOpen = (staff) => {
    this.setState({
      currentStaff: staff,
      staffDialogOpen: true
    });
  }

  handleStaffDialogClose = () => {
    this.setState({
      currentStaff: null,
      staffDialogOpen: false
    });
  }

  componentDidMount() {
    const unsubscribeCurrentUser = this.listenCurrentUser();
    const unsubscribeUserPasses = this.queryUserPasses();
    const unsubscribePasses = this.queryPasses();
    const unsubscribePriceRule = this.queryPriceRule();
    const unsubscribeRoles = this.queryRoles();
    const unsubscribeBranches = this.queryBranches();
    const unsubscribeStaffs = this.queryStaffs();
    const unsubscribeUsers = this.queryUsers();
    // const unsubscribeRooms = this.queryRooms();
    // const unsubscribeBookingStatus = this.queryBookingStatus();

    this.setState({
      unsubscribeCurrentUser,
      unsubscribeUserPasses,
      unsubscribePasses,
      unsubscribePriceRule,
      unsubscribeRoles,
      unsubscribeBranches,
      unsubscribeStaffs,
      unsubscribeUsers,
    });
  }

  componentWillUnmount() {
    this.state.unsubscribeCurrentUser && this.state.unsubscribeCurrentUser();
    this.state.unsubscribeUsers && this.state.unsubscribeUsers();
    this.state.unsubscribeUserPasses && this.state.unsubscribeUserPasses();
    this.state.unsubscribePasses && this.state.unsubscribePasses();
    this.state.unsubscribeRooms && this.state.unsubscribeRooms();
    this.state.unsubscribeBookingStatus && this.state.unsubscribeBookingStatus();
    this.state.unsubscribePriceRule && this.state.unsubscribePriceRule();
    this.state.unsubscribeRoles && this.state.unsubscribeRoles();
    this.state.unsubscribeBranches && this.state.unsubscribeBranches();
    this.state.unsubscribeStaffs && this.state.unsubscribeStaffs();
    this.worker.terminate();
  }

  render() {
    const { classes } = this.props;

    const currentUserRole = this.getCurrentUserRole();
    const currentUserBranchId = this.getCurrentUserBranchId();

    const page = this.state.page;
    const pageId = page && page.id;
    const branch = page && page.branch;
    const branchId = branch && branch.id;
    const priceRule = _.filter(this.state.priceRule, rule => rule.branch === branchId);
    const passes = _.filter(this.state.passes, pass => pass.branch === branchId);

    var content = null;
    var menuItems = null;
    var titleSuffex = '';
    var max = moment().subtract(1, 'days');
    switch (pageId) {
      case PAGE_DESKS_IN_USE.id:
        content = <DeskInUseTable
          branchId={branchId}
          users={this.state.users}
          passes={this.state.passes}
          priceRule={priceRule}
          userPasses={this.state.userPasses}
        />;
        menuItems = (
          <Button
            color="inherit"
            onClick={this.handleDeskTransactionDialogOpen} >
            Check-In
          </Button>
        );
        titleSuffex = moment().format('ll');
        break;
      case PAGE_DESKS_HISTORY.id:
        content = <DeskHistoryTable
          currentUser={this.state.currentUser}
          branchId={branchId}
          passes={this.state.passes}
          date={this.state.deskHistoryPageSelectedDate}
          users={this.state.users}
        />;
        titleSuffex = (
          <TextField
            type="date"
            value={(this.state.deskHistoryPageSelectedDate ? moment(this.state.deskHistoryPageSelectedDate) : max).format('YYYY-MM-DD')}
            onChange={event => {
              this.setState({
                deskHistoryPageSelectedDate: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : max.toDate()
              });
            }}
            InputProps={{
              inputProps: {
                // max: max.format('YYYY-MM-DD'),
              },
              disableUnderline: true,
              classes: {
                input: classes.dateFieldContrast,
              },
            }}
          />
        );
        break;
      case PAGE_PASS_REPORT.id:
        content = <PassReportPage date={this.state.reportPageSelectedDate} />;
        break;
      case PAGE_BOOKINGS.id:
        content = <RoomScheduleTable rooms={this.state.rooms} />;
        titleSuffex = moment().format('ll');
        menuItems = (
          <div>
            <Button
              onClick={() => {

              }}
              color="inherit" >
              CLEAN
            </Button>
            <Button
              color="inherit" >
              NEW APPLICATION
            </Button>
          </div>
        );
        break;
      case PAGE_BOOKINGS_APPLICATION.id:
        content = <RoomApplicationTable rooms={this.state.rooms} bookingStatus={this.state.bookingStatus} />
        titleSuffex = moment().format('ll');
        break;
      case PAGE_BOOKINGS_HISTORY.id:
        content = <RoomHistoryTable rooms={this.state.rooms} bookingStatus={this.state.bookingStatus} date={this.state.deskHistoryPageSelectedDate} />
        titleSuffex = (
          <TextField
            type="date"
            value={(this.state.deskHistoryPageSelectedDate ? moment(this.state.deskHistoryPageSelectedDate) : max).format('YYYY-MM-DD')}
            onChange={event => {
              this.setState({
                deskHistoryPageSelectedDate: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : max.toDate()
              });
            }}
            InputProps={{
              inputProps: {
                // max: max.format('YYYY-MM-DD'),
              },
              disableUnderline: true,
              classes: {
                input: classes.dateFieldContrast,
              },
            }}
          />
        );
        break;
      case PAGE_CUSTOMERS.id:
        content = <CustomersTable
          currentUser={this.state.currentUser}
          users={this.state.users}
          userPasses={this.state.userPasses}
          passes={this.state.passes}
          branches={this.state.branches}
          branchId={currentUserBranchId}
        />;
        menuItems = (
          <div>
            <Button
              color="inherit"
              onClick={this.handleImportCustomerFormOpen} >
              IMPORT
            </Button>
            <Button
              color="inherit"
              onClick={this.handleRegistrationDialogOpen} >
              REGISTER
            </Button>
          </div>
        );
        break;
      case PAGE_STUDY_GROUP.id:

        break;
      case PAGE_EVENTS.id:

        break;
      case PAGE_POSTS.id:

        break;
      case PAGE_DESK.id:
        content = <RoomTable rooms={this.state.rooms} />;
        break;
      case PAGE_PASSES.id:
        content = <PassesTable passes={passes} />;
        break;
      case PAGE_PRICE.id:
        content = <PriceTable priceRule={priceRule} />;
        break;
      case PAGE_STAFFS.id: {
        content = <StaffsTable staffs={this.state.staffs} onEditStaff={(staff) => this.handleStaffDialogOpen(staff)} />;

        menuItems = (
          <div>
            <Button
              color="inherit"
              onClick={() => this.handleStaffDialogOpen()} >
              ADD
            </Button>
          </div>
        );

        break;
      }
      case PAGE_REPORT.id:
        content = <ReportPage
          branchId={this.state.page.branch.id}
          date={this.state.reportPageSelectedDate}
          passes={this.state.passes}
          users={this.state.users}
        />;
        titleSuffex = "last updated on " + moment(this.state.reportPageSelectedDate).format('lll');
        menuItems = (
          <div>
            <Button
              color="inherit"
              onClick={() => this.setState({ reportPageSelectedDate: moment().toDate() })} >
              REFRESH
            </Button>
          </div>
        );
        break;
      case PAGE_HISTORY_REPORT.id:
        content = <ReportPage
          branchId={this.state.page.branch.id}
          date={this.state.historyReportPageSelectedDate}
          passes={this.state.passes}
          users={this.state.users}
        />;
        titleSuffex = (
          <TextField
            type="date"
            value={(this.state.historyReportPageSelectedDate ? moment(this.state.historyReportPageSelectedDate) : max).format('YYYY-MM-DD')}
            onChange={event => {
              this.setState({
                historyReportPageSelectedDate: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : max.toDate()
              });
            }}
            InputProps={{
              inputProps: {
                // max: max.format('YYYY-MM-DD'),
              },
              disableUnderline: true,
              classes: { input: classes.dateFieldContrast, },
            }}
          />
        );
        break;
      case PAGE_EXPORT.id:
        content = <ExportPage users={this.state.users} />;
        break;
      case PAGE_TEST.id:
        content = <TestPage />;
        break;
      default:
    }

    var mi_pass_report = this.genMenuItem(PAGE_PASS_REPORT);
    var mi_customers = this.genMenuItem(PAGE_CUSTOMERS);
    var mi_staffs = this.genMenuItem(PAGE_STAFFS);
    var mi_export = this.genMenuItem(PAGE_EXPORT);
    var mi_clearCache = (
      <ListItem
        key="clear_cache"
        button
        onClick={() => {
          this.setState({
            dialogOpen: true,
            dialogTitle: 'Clear cache and refresh',
            dailogButtonText: 'REFRESH',
            dialogMessage: 'Please clear and refresh after a new version released.',
            dialogAction: () => window.location.reload(),
          });
        }} >
        <ListItemIcon>
          <Icon>cached</Icon>
        </ListItemIcon>
        <ListItemText primary="Clear Cache" />
      </ListItem>
    );

    var operationsItems = [];
    var settingsItems = [];
    var toolsItems = [];

    // Operations
    operationsItems.push(...this.genBranchMenuItems());
    mi_pass_report && operationsItems.push(mi_pass_report);

    // Settings
    mi_customers && settingsItems.push(mi_customers);
    mi_staffs && settingsItems.push(mi_staffs);

    // Tools
    if (mi_export) toolsItems.push(mi_export);
    toolsItems.push(mi_clearCache);

    var ml_operations = (operationsItems.length > 0 ?
      <List key="ml_operations" className={classes.list} subheader={this.state.drawerOpen ? <ListSubheader>Operations</ListSubheader> : null}>
        {operationsItems}
      </List> : null
    );
    var ml_settings = (settingsItems.length > 0 ?
      <List key="ml_settings" className={classes.list} subheader={this.state.drawerOpen ? <ListSubheader>Settings</ListSubheader> : null}>
        {settingsItems}
      </List> : null
    );
    var ml_tools = (toolsItems.length > 0 ?
      <List key="ml_tools" className={classes.list} subheader={this.state.drawerOpen ? <ListSubheader>Tools</ListSubheader> : null}>
        {toolsItems}
      </List> : null
    );

    var menuLists = [];
    if (ml_operations) menuLists.push(ml_operations);
    if (ml_settings) {
      menuLists.push(<Divider key="d1" />);
      menuLists.push(ml_settings);
    }
    if (ml_tools) {
      menuLists.push(<Divider key="d2" />);
      menuLists.push(ml_tools);
    }

    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>

          {/* AppBar */}
          <AppBar className={classNames(classes.appBar, this.state.drawerOpen && classes.appBarShift)}>
            <Toolbar disableGutters={!this.state.drawerOpen}>

              {/*
              <IconButton
                color="inherit"
                onClick={this.handleDrawerOpen}
                className={classNames(classes.menuButton, this.state.drawerOpen && classes.hide)} >
                <MenuIcon />
              </IconButton>
              */}

              <Typography variant="h6" color="inherit" noWrap className={classes.flex}>
                {(this.state.page.title || '') +
                  ((this.state.page.branch && ` (${this.state.page.branch.name})`) || '') +
                  (titleSuffex && '\u00a0-\u00a0')}
                {titleSuffex}
              </Typography>

              {menuItems}

            </Toolbar>
          </AppBar>

          {/* Drawer */}
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(classes.drawerPaper, !this.state.drawerOpen && classes.drawerPaperClose),
            }}
            open={this.state.drawerOpen} >

            <div className={classes.drawerInner}>

              <div className={classes.drawerHeader}>
                <div>
                  <Typography variant="h5" color="textSecondary" noWrap style={{ fontFamily: "Montserrat" }}>
                    MyBASE Admin
                  </Typography>
                  <Typography variant="caption" color="textSecondary" noWrap style={{ fontFamily: "Montserrat" }}>
                    v{this.props.version} ・ {(currentUserRole && currentUserRole.name) || ''} ・ {currentUserBranchId || ''}
                  </Typography>
                </div>
                {/*
                <IconButton onClick={this.handleDrawerClose}>
                  {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
                */}
              </div>

              <Divider />

              {this.state.currentUser && this.state.roles ?
                <div>

                  {/* Bookings */}
                  {/*
                {this.genMenuItem(PAGE_BOOKINGS, PERMISSION_TODO, <DateRangeIcon />, false, 'roomMenuOpen')}
                <Collapse component="li" in={this.state.roomMenuOpen} timeout="auto" unmountOnExit>
                  <List disablePadding>
                    {this.genMenuItem(PAGE_BOOKINGS_APPLICATION, PERMISSION_TODO, <DescriptionIcon />, true)}
                    {this.genMenuItem(PAGE_BOOKINGS_HISTORY, PERMISSION_TODO, <HistoryIcon />, true)}
                  </List>
                </Collapse>
                */}

                  {/* Events */}
                  {/*
                {this.genMenuItem(PAGE_EVENTS, PERMISSION_TODO, <EventIcon />)}
                */}

                  {/* Groups */}
                  {/*
                {this.genMenuItem(PAGE_STUDY_GROUP, PERMISSION_TODO, <GroupWorkIcon />)}
                */}

                  {/* Posts */}
                  {/*
                {this.genMenuItem(PAGE_POSTS, PERMISSION_TODO, <RssFeedIcon />)}
                */}

                  {menuLists}

                  <Divider />

                  {/* Others */}
                  <List className={classes.list}>

                    {/* Reset Password */}
                    <ListItem button
                      onClick={this.handleResetPassword} >
                      <ListItemIcon>
                        <LockIcon />
                      </ListItemIcon>
                      <ListItemText primary="Reset Password" />
                    </ListItem>

                    {/* Sign Out */}
                    <ListItem button
                      onClick={this.handleSignOut} >
                      <ListItemIcon>
                        <ExitToAppIcon />
                      </ListItemIcon>
                      <ListItemText primary="Sign out" />
                    </ListItem>

                    {/* TEST */}
                    {false ?
                      this.genMenuItem(PAGE_TEST)
                      : null}
                  </List>

                </div>
                : null}

            </div>

          </Drawer>

          {/* Dialog */}
          <Dialog open={this.state.dialogOpen} onClose={this.handleDialogClose}>
            <DialogTitle>{this.state.dialogTitle}</DialogTitle>
            <DialogContent>
              <DialogContentText>{this.state.dialogMessage}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.state.dialogAction} color="primary">
                {this.state.dailogButtonText || this.state.dialogTitle}
              </Button>
            </DialogActions>
          </Dialog>

          <ImportCustomerDialog
            open={this.state.importCustomerFormOpen}
            onRequestClose={this.handleImportCustomerFormClose} />

          <CheckInDialog
            users={this.state.users}
            branchId={this.state.page && this.state.page.branch && this.state.page.branch.id}
            open={this.state.deskTransactionDialogOpen}
            onRequestClose={this.handleDeskTransactionDialogClose} />

          <ResetPasswordDialog
            open={this.state.resetPasswordDialogOpen}
            onRequestClose={this.handleResetPasswordDialogClose} />

          <StaffDailog
            open={this.state.staffDialogOpen}
            staff={this.state.currentStaff}
            onRequestClose={this.handleStaffDialogClose} />

          {/* Content */}
          <main className={classes.content}>
            {content}
          </main>

          {/* Loading */}
          <Backdrop style={{ zIndex: 10000 }} open={this.state.loading}>
            <CircularProgress />
          </Backdrop>

        </div>
      </div>
    );
  }
}

MainDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  version: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(MainDrawer);
